<template>
  <VDatePicker v-model.string="date" :locale="locale" :masks="masks" :max-date="new Date()"  mode="date" @dayclick="onDateChange">
    
    <template v-slot="{ inputValue, inputEvents }">
      <Input
        :input-styles="{ cursor: 'pointer !important' }"
        focused
        readOnly
        :value="inputValue"
        :label="t('travellers.age')"
        :inputEvents="inputEvents"
        :error="error"
        :show-error="showError"
        inputType="text"
      >
    </Input>
    </template>
  </VDatePicker>
</template>

<script lang="ts" setup>
  // Vue
  import {
    ref,
    Ref,
    defineProps,
    ComputedRef,
    computed,
    defineEmits,
    watch
  } from 'vue'

  // Components
  import Input from './Input.vue'

  //Store
  import { useStore } from '@/store'
  const store = useStore()

  // Translations
  import { useI18n } from 'vue-i18n'
  const { t, d } = useI18n()

  // VCalendar
  interface AttributeConfig {
    dot: boolean | string
    highlight: boolean | string
  }

  // Props
  interface Props {
    date: string
    error?: string
    showError?: boolean
  }

  const props = defineProps<Props>()

  // Emit
  const emit = defineEmits<{
    (e: 'dateChange', value: string): void
  }>()

  // Refs
  const date: Ref<string> = ref(props.date)

    
    const masks = ref({
      modelValue: 'YYYY-MM-DD',
    });

  // Computed
  const locale = computed<string>(() => {
    // Fetching and processing locale
    const rawLocale = store.getters.getLocale || 'en' // Default to 'en' if not set
    const currentLocale = rawLocale.split('-')[0] // Extract the language code (e.g., 'fr' from 'fr-FR')
    return currentLocale
  })

  const validateDateFormat = (value: string): boolean => {
    const dateRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/; // YYYY-MM-DD format
    return dateRegex.test(value)
  }

// Methods
const onDateChange = (): void => {
  console.log("date.value: ",date.value)
  if (validateDateFormat(date.value)) {
    emit("dateChange", date.value); // Emit the event if the date is valid
  } else {
    console.error("Invalid date format. Please use YYYY-MM-DD.");
  }
};


</script>

<style>
  .vc-popover-caret {
    display: none;
  }

  .vc-popover-content-wrapper {
    width: 100%;
  }

  .vc-container {
    padding: 0 1.2em;
    min-width: 100%;
  }

  .vc-pane-container {
    min-width: 100%;
  }

  .vc-arrow {
    background: none;
  }
</style>
